import { PhoneCountry } from '../../models/serializable/phone-country.js';
import { isNotNullOrUndefined } from '../../utility/null-safety.js';
import { GenericPhoneNumberValidator } from './generic-phone-number-validator.js';
import { HungarianPhoneNumberValidator } from './hungarian-phone-number-validator.js';
import { PhoneNumberValidator } from './phone-number-validator.js';
import { RomanianPhoneNumberValidator } from './romanian-phone-number-validator.js';

export class PhoneNumberValidatorFactory {
  static validators: Map<PhoneCountry, PhoneNumberValidator> = new Map([
    [PhoneCountry.Albania, new GenericPhoneNumberValidator()],
    [PhoneCountry.Andorra, new GenericPhoneNumberValidator()],
    [PhoneCountry.Armenia, new GenericPhoneNumberValidator()],
    [PhoneCountry.Austria, new GenericPhoneNumberValidator()],
    [PhoneCountry.Azerbaijan, new GenericPhoneNumberValidator()],
    [PhoneCountry.Belarus, new GenericPhoneNumberValidator()],
    [PhoneCountry.Belgium, new GenericPhoneNumberValidator()],
    [PhoneCountry.BosniaAndHerzegovina, new GenericPhoneNumberValidator()],
    [PhoneCountry.Bulgaria, new GenericPhoneNumberValidator()],
    [PhoneCountry.Croatia, new GenericPhoneNumberValidator()],
    [PhoneCountry.Cyprus, new GenericPhoneNumberValidator()],
    [PhoneCountry.CzechRepublic, new GenericPhoneNumberValidator()],
    [PhoneCountry.Denmark, new GenericPhoneNumberValidator()],
    [PhoneCountry.Estonia, new GenericPhoneNumberValidator()],
    [PhoneCountry.FaroeIslands, new GenericPhoneNumberValidator()],
    [PhoneCountry.Finland, new GenericPhoneNumberValidator()],
    [PhoneCountry.France, new GenericPhoneNumberValidator()],
    [PhoneCountry.Georgia, new GenericPhoneNumberValidator()],
    [PhoneCountry.Germany, new GenericPhoneNumberValidator()],
    [PhoneCountry.Gibraltar, new GenericPhoneNumberValidator()],
    [PhoneCountry.Greece, new GenericPhoneNumberValidator()],
    [PhoneCountry.Hungary, new HungarianPhoneNumberValidator()],
    [PhoneCountry.Iceland, new GenericPhoneNumberValidator()],
    [PhoneCountry.Ireland, new GenericPhoneNumberValidator()],
    [PhoneCountry.Italy, new GenericPhoneNumberValidator()],
    [PhoneCountry.Latvia, new GenericPhoneNumberValidator()],
    [PhoneCountry.Liechtenstein, new GenericPhoneNumberValidator()],
    [PhoneCountry.Lithuania, new GenericPhoneNumberValidator()],
    [PhoneCountry.Luxembourg, new GenericPhoneNumberValidator()],
    [PhoneCountry.NorthMacedonia, new GenericPhoneNumberValidator()],
    [PhoneCountry.Malta, new GenericPhoneNumberValidator()],
    [PhoneCountry.RepublicOfMoldova, new GenericPhoneNumberValidator()],
    [PhoneCountry.Monaco, new GenericPhoneNumberValidator()],
    [PhoneCountry.Montenegro, new GenericPhoneNumberValidator()],
    [PhoneCountry.Netherlands, new GenericPhoneNumberValidator()],
    [PhoneCountry.Norway, new GenericPhoneNumberValidator()],
    [PhoneCountry.Poland, new GenericPhoneNumberValidator()],
    [PhoneCountry.Portugal, new GenericPhoneNumberValidator()],
    [PhoneCountry.Romania, new RomanianPhoneNumberValidator()],
    [PhoneCountry.Russia, new GenericPhoneNumberValidator()],
    [PhoneCountry.SanMarino, new GenericPhoneNumberValidator()],
    [PhoneCountry.Serbia, new GenericPhoneNumberValidator()],
    [PhoneCountry.Slovakia, new GenericPhoneNumberValidator()],
    [PhoneCountry.Slovenia, new GenericPhoneNumberValidator()],
    [PhoneCountry.Spain, new GenericPhoneNumberValidator()],
    [PhoneCountry.Sweden, new GenericPhoneNumberValidator()],
    [PhoneCountry.Switzerland, new GenericPhoneNumberValidator()],
    [PhoneCountry.Turkey, new GenericPhoneNumberValidator()],
    [PhoneCountry.Ukraine, new GenericPhoneNumberValidator()],
    [PhoneCountry.UnitedKingdom, new GenericPhoneNumberValidator()],
    [PhoneCountry.VaticanCity, new GenericPhoneNumberValidator()],
  ]);

  static ofCountry(country: PhoneCountry): PhoneNumberValidator {
    const validator = this.validators.get(country);
    if(isNotNullOrUndefined(validator)) {
      return validator;
    }

    throw new Error(`Failed to find phone number validator for country: ${country}`);
  }

  static hasForCountry(country: PhoneCountry): boolean {
    return this.validators.has(country);
  }
}
